import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AppFrameContextService, CommonBrowserStorageService, AppClientConfigurationService, DialogService, AppServerAPI, ServiceResponse } from '@sdbn/common';
import { AsyncSubject, Subscription, concat } from 'rxjs';
import { EntranceSight, TransportCreationProfileSight } from '../cep-tablet.model';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';


@Component({
    selector: 'app-cep-tablet',
    templateUrl: './cep-tablet.component.html',
    styleUrls: ['./cep-tablet.component.scss'],
    standalone: false
})
export class CEPTabletComponent implements OnInit, OnDestroy {

  profiles = new Array<TransportCreationProfileSight>();
  entrances = new Array<EntranceSight>();

  showBarrierSelection = true;

  isLoading = false;

  formGroup = new FormGroup({
    bookEntrance: new FormControl(false, []),
    entrance: new FormControl(null, [])
  });

  subscription: Subscription;

  /* browser storage parameter */
  componentId = 'cep-tablet';
  bookEntranceStorageKey = 'book-entrance';
  entranceStorageKey = 'entrance-id';


  @Input()
  cameraUrl: string;

  constructor(
    private appFrameContextService: AppFrameContextService,
    private appServerAPI: AppServerAPI,
    private configurationService: AppClientConfigurationService,
    private dialogService: DialogService,
    private storageService: CommonBrowserStorageService
  ) {
  }

  valuesChanging: boolean;

  ngOnInit(): void {

    concat(
      this.loadProfiles(),
      this.loadEntrances()
    ).subscribe(() => {

      this.loadSelection();

      this.subscription = this.formGroup.valueChanges.subscribe(values => {

        if (this.valuesChanging) {
          return;
        }
        this.valuesChanging = true;

        this.updateFieldEnablement();
        this.storeSelection();

        this.valuesChanging = false;

      });

    });

  }

  private loadProfiles(): AsyncSubject<void> {
    const subject = new AsyncSubject<void>();
    this.appServerAPI.execute<Array<TransportCreationProfileSight>>('/client/control/cep-tablet/transport-creation-profiles', null).subscribe(response => {
      let profiles = new Array<TransportCreationProfileSight>();
      for (const profile of response) {
        profiles.push(new TransportCreationProfileSight(profile));
      }
      this.profiles = profiles;
      subject.next();
      subject.complete();
    }, error => {
      subject.error('');
    });
    return subject;
  }

  private loadEntrances(): AsyncSubject<void> {
    const subject = new AsyncSubject<void>();
    this.appServerAPI.execute<Array<TransportCreationProfileSight>>('/client/control/cep-tablet/get-entrances', null).subscribe(response => {
      let entrances = new Array<EntranceSight>();
      for (const entrance of response) {
        entrances.push(new EntranceSight(entrance));
      }

      this.entrances = entrances;

      if (entrances.length > 0) {
        this.formGroup.patchValue({ entrance: entrances[0] });
      }

      this.updateFieldEnablement();
      subject.next();
      subject.complete();
    }, error => {
      subject.error('');
    });
    return subject;
  }

  ngOnDestroy() {
  }

  handleProfileClick(profile: TransportCreationProfileSight) {

    console.log('profile clicked', profile);

    this.isLoading = true;

    let property = this.configurationService.getPropertyValue('tmc-yard.ui.control.cep.request-confirm', 'false');
    let requirersConfirm = property === 'true';

    if (requirersConfirm) {
      this.dialogService.showConfirm('tmc-yard.ui.control.cep.confirm.title', 'tmc-yard.ui.control.cep.confirm.description').afterClosed().subscribe(confirm => {
        console.log('dialog confirmed', confirm);
        if (confirm) {
          this.doProfileCreation(profile);
        } else {
          this.isLoading = false;
        }
      })
    } else {
      this.doProfileCreation(profile);
    }
  }

  private doProfileCreation(profile: TransportCreationProfileSight) {

    console.log('form values are', this.formGroup.value);

    let request = {
      profileId: profile.id,
      bookEntrance: this.formGroup.value['bookEntrance'],
      entranceId: this.formGroup.value['entrance']?.id
    };

    this.appServerAPI.execute<ServiceResponse>('/client/control/cep-tablet/create-transport-by-profile', request).subscribe(response => {

      console.log('request finished', response);

      // TODO handling nötig ??

      this.isLoading = false;
    }, error => {

      this.isLoading = false;
    })


  }

  private updateFieldEnablement() {

    let bookEntrance: boolean = this.formGroup.value['bookEntrance'];

    if (!bookEntrance) {
      this.formGroup.controls['entrance'].disable();
    } else {
      this.formGroup.controls['entrance'].enable();
    }
  }

  private storeSelection() {

    const bookEntrance: boolean = this.formGroup.value['bookEntrance'];
    const entrance: EntranceSight = this.formGroup.value['entrance'];

    this.storageService.setPersistent(this.appFrameContextService.tenant.value.key, this.componentId, this.bookEntranceStorageKey, '' + bookEntrance);
    if (entrance != null) {
      this.storageService.setPersistent(this.appFrameContextService.tenant.value.key, this.componentId, this.entranceStorageKey, '' + entrance.id);
    } else {
      // todo remove key from storage
    }
  }

  private loadSelection() {

    const bookEntrance = this.storageService.get(this.appFrameContextService.tenant.value.key, this.componentId, this.bookEntranceStorageKey);
    const entranceId = this.storageService.get(this.appFrameContextService.tenant.value.key, this.componentId, this.entranceStorageKey);

    if (bookEntrance != null) {
      this.formGroup.controls['bookEntrance'].setValue(bookEntrance === 'true');
    }

    if (entranceId != null && entranceId != 'undefined') {
      this.formGroup.controls['entrance'].setValue(this.findEntranceById(parseInt(entranceId)));
    }

  }

  private findEntranceById(id: number) : EntranceSight {
    for (const entrance of this.entrances) {
      if (entrance.id === id) {
        return entrance;
      }
    }
    return null;
  }

}
